$(document).ready(function () {
setTimeout(function() {
  $(".default-color").trigger("click");
  }, 1000);

  
// $(".size_wrpes").click(function(){

//     $(this).siblings(".size_popups").addClass("popup_open");
//     $("body").addClass("popup_body");
  
//   $(this).siblings(".size_popups").show();
// });

  $(".size_wrpes.desktop_size_chart").click(function(){

    $(".size_popups.desktop_size_popups").addClass("popup_open");
    $("body").addClass("popup_body");
  
  $(".size_popups.desktop_size_popups").show();
});

  $(".size_wrpes.mob_size_wrpes").click(function(){

    $(".size_popups.mob_size_popups").addClass("popup_open");
    $("body").addClass("popup_body");
  
  $(".size_popups.mob_size_popups").show();
});

  
$(".close-popup").click(function(){

    $(this).parents(".size_popups").removeClass("popup_open");
  $(this).parents(".size_popups").hide();
  $("body").removeClass("popup_body");
  
});




// product slider
/* $('.cstm_nav_top').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: false,
  dots: true,
  asNavFor: '.cstm_nav_bottom'
});
$('.cstm_nav_bottom').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  asNavFor: '.cstm_nav_top',
  dots: false,
  centerMode: false,
  focusOnSelect: true
});*/




function checkIfVariantExists() {
  console.log("🔍 Starting multilingual variant existence check...");

  // 🧹 Helper: clean text but keep Arabic & non-Latin letters
  function cleanText(str) {
    return (str || "")
      .normalize("NFKC") // normalize Unicode for consistency
      .replace(/[\uFE0F\u00A0\u200B\uFEFF]/g, "") // remove invisible chars
      .replace(/[\u{1F300}-\u{1FAFF}]/gu, "") // remove emoji range
      .replace(/[^\p{L}\p{N}\s]/gu, "") // keep all letters (Arabic, Latin, etc.)
      .trim()
      .toLowerCase();
  }

  // 🧩 Step 1: Collect selected options dynamically from fieldsets
  const selectedOptions = {};
  document.querySelectorAll(".product-block-variant-picker fieldset").forEach((fieldset, index) => {
    const legendEl = fieldset.querySelector("legend");
    const labelRaw = legendEl ? legendEl.dataset.lagendname || legendEl.textContent : "";
    const label = cleanText(labelRaw);

    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    const value = checkedInput ? cleanText(checkedInput.value) : null;

    console.log(`🧩 Fieldset ${index + 1} detected:`, { labelRaw, label, value });

    if (label && value) {
      selectedOptions[label] = value;
    }
  });

  // 🧠 Step 2: log what we gathered
  console.log("🧠 All selected options (cleaned):", selectedOptions);

  const labels = Object.keys(selectedOptions);
  if (labels.length === 0) {
    console.warn("⚠️ No valid fieldsets with checked options found!");
    return false;
  }

  // 📋 Step 3: Loop through all options in the hidden select
  const allOptions = document.querySelectorAll(".cstm_variant_all option");
  console.log(`📋 Found ${allOptions.length} total options inside .cstm_variant_all`);

  let found = false;
  let matchedValue = null;

  allOptions.forEach((opt, i) => {
    const optSize = cleanText(opt.getAttribute("data-size"));
    const optColor = cleanText(opt.getAttribute("data-color"));
    const optAvail = opt.getAttribute("data-availab");
    const optValue = opt.value;

    console.log(`➡️ Option ${i + 1}:`, {
      value: optValue,
      optSize,
      optColor,
      optAvail,
    });

    // Check if all relevant selected options match
    let match = true;
    for (const key in selectedOptions) {
      const val = selectedOptions[key];

      if (
        (key.includes("size") || key.includes("thickness") || key.includes("سماكة")) &&
        val !== optSize
      ) {
        match = false;
        break;
      }
      if (
        (key.includes("color") || key.includes("colour") || key.includes("لون")) &&
        val !== optColor
      ) {
        match = false;
        break;
      }
    }

    if (match) {
      console.log(`✅ MATCH FOUND at option ${i + 1}:`, {
        optValue,
        optSize,
        optColor,
        optAvail,
      });
      found = true;
      matchedValue = optValue;
    }
  });

  // 🎯 Step 4: Apply the match to the select (if found)
  if (found && matchedValue) {
    const selectEl = document.querySelector(".cstm_variant_all");
    if (selectEl) {
      selectEl.value = matchedValue;
      const event = new Event("change", { bubbles: true });
      selectEl.dispatchEvent(event);
      console.log(`🎉 Selected variant updated to value: ${matchedValue}`);
    } else {
      console.warn("⚠️ .cstm_variant_all not found in DOM!");
    }
  }

  // ✅ Step 5: Final log
  if (found) {
    console.log("✅ Final Result: Matching variant found and applied!");
  } else {
    console.log("❌ Final Result: No matching variant found!");
  }

  return found;
}



  // image change on change variant

  $("fieldset").change(function(){

            if (document.body.classList.contains("cstm_coch-hoddie-landing-page")) {
            const picker = document.querySelector(".product-block-variant-picker");
            const select = document.querySelector(".cstm_variant_all");
            if (picker && select) {
            // clearInterval(interval);
            console.log("🚀 Variant picker detected, initializing...");
            // checkIfVariantExists();
            var is_opt_avail = true;
            console.log("col_val",checkIfVariantExists)
            if(checkIfVariantExists())
            {
            is_opt_avail = true;
            }else{
            is_opt_avail =  false;
            }
            }
            }

              var imageId = $('.cstm_variant_all option[selected]').data('image_id');
              var inventorypolicy = $('.cstm_variant_all option[selected]').data('inventorypolicy');
    
              const $btn = $('.cta-button.cstm-checkout-btn');
              
              const checkBtnText = $btn.attr('data-checkbtn');
              const soldBtnText = $btn.attr('data-soldbtn');
              const preorderBtnText = $btn.attr('data-preorderbtn');
              const unavailableBtnText = $btn.attr('data-unavailablebtn');
    
             console.log(inventorypolicy + ' testt');
    
              console.log('Selected data_image_ids:', imageId);
              // The target Mead ID you want to match
              const targetMeadId = imageId; // Replace with your target ID
              // Loop through all slides in the slick carousel

              var curr_qty = $('.cstm_variant_all option[selected]').data('qty');
              console.log('qty',curr_qty);
              curr_qty = parseInt(curr_qty, 10);
    
                var $wrapper = $('.check-qty-wrapp');
                var $checkoutBtn = $wrapper.find('.cta-button a');
                
                // if (curr_qty < 1) {
                // // Disable styles
                // $wrapper.css({
                // 'pointer-events': 'none',
                // 'opacity': '0.5'
                // });
                
                //     // Change button text
                //     $checkoutBtn.text(soldBtnText);
                //     if(inventorypolicy == 'continue'){
                //       $checkoutBtn.text(preorderBtnText);
                //       $wrapper.css({
                //       'pointer-events': 'auto',
                //       'opacity': '1'
                //       });
                //     }else{
                      
                //     }
                // } else {
                // // Enable styles
                // $wrapper.css({
                // 'pointer-events': 'auto',
                // 'opacity': '1'
                // });
                
                // // Restore button text
                // $checkoutBtn.text(checkBtnText);
                // }

                if (document.body.classList.contains("cstm_coch-hoddie-landing-page")) {  
                if(is_opt_avail){
                
                if (curr_qty < 1) {
                // Disable styles
                $wrapper.css({
                'pointer-events': 'none',
                'opacity': '0.5'
                });
                
                    // Change button text
                    $checkoutBtn.text(soldBtnText);
                    if(inventorypolicy == 'continue'){
                      $checkoutBtn.text(preorderBtnText);
                      $wrapper.css({
                      'pointer-events': 'auto',
                      'opacity': '1'
                      });
                    }else{
                      
                    }
                } else {
                // Enable styles
                    $wrapper.css({
                    'pointer-events': 'auto',
                    'opacity': '1'
                    });
                
                // Restore button text
                $checkoutBtn.text(checkBtnText);
                }

              }else{

                  $wrapper.css({
                'pointer-events': 'none',
                'opacity': '0.5'
                });
                
                    // Change button text
                    $checkoutBtn.text(unavailableBtnText);
              }
              }else{

                if (curr_qty < 1) {
                // Disable styles
                $wrapper.css({
                'pointer-events': 'none',
                'opacity': '0.5'
                });
                
                    // Change button text
                    $checkoutBtn.text(soldBtnText);
                    if(inventorypolicy == 'continue'){
                      $checkoutBtn.text(preorderBtnText);
                      $wrapper.css({
                      'pointer-events': 'auto',
                      'opacity': '1'
                      });
                    }else{
                      
                    }
                } else {
                // Enable styles
                    $wrapper.css({
                    'pointer-events': 'auto',
                    'opacity': '1'
                    });
                
                // Restore button text
                $checkoutBtn.text(checkBtnText);
                }

              

              }

    $('.cstm_nav_bottom .slick-slide').each(function(index) {
  const slideMeadId = $(this).find('li').data('meadid');
  const indexId = $(this).data('slick-index');

  if (slideMeadId == targetMeadId) {
    console.log("Match found at index:", indexId);

    // Simulate a click on the slide
    $(this).trigger('click');

    // Optional: log which one was clicked
    console.log("Clicked on slick-slide with Mead ID:", slideMeadId);

    return false; // Exit loop
  }
});
    
// $('.cstm_nav_top .slick-slide').each(function(index) {
//   // Get the data-meadid from the <li> inside the current slide
//   const slideMeadId = $(this).find('li').data('meadid');

//   const indexId = $(this).data('slick-index');
  
//   // Check if the current slide's data-meadid matches the target
//   if (slideMeadId == targetMeadId) {
//     // Use Slick's slickGoTo method to go to the matched slide's index
//     console.log("Navigated to slide with Mead ID test:", indexId);
    
//     $('.cstm_nav_top').slick('slickGoTo', indexId);
//     console.log("Navigated to slide with Mead ID:", indexId);
//     return false; // Exit loop after finding the match
//   }
// });

    
setTimeout(function() {
    updatepercentageOff();
   }, 500);
    
});

  function updatepercentageOff(){
    var salePrice = parseFloat($('.current-price').text().replace(/[^0-9.]/g, ''));
  var originalPrice = parseFloat($('[data-compare-price]').text().replace(/[^0-9.]/g, ''));
  var prc_el = $(".cstn-off_prc");
  var offText = prc_el.data("offtext");
  var currSymb = $("body").data("currsymb");


  if (!isNaN(salePrice) && !isNaN(originalPrice) && originalPrice > salePrice) {
    var saved = originalPrice - salePrice;
    var percentOff = (saved / originalPrice) * 100;

    var savedFormatted = currSymb + saved.toFixed(2);
    var percentFormatted = Math.round(percentOff);

    // Create the HTML
    var discountHtml = `
      <div class="cstn-off_prc">
        <span class="badge badge--sale"><span>${percentFormatted}%</span></span>
         ${offText} ${savedFormatted}
      </div>
    `;

    // Append or insert it where you want (adjust selector as needed)
    $('.cstn-off_prc').html(discountHtml);
  }
  }


  

  
    $('.qty-btn.plus').click(function () {
      let $input = $(this).siblings('.qty-input');
      let val = parseInt($input.val());
      $input.val(val + 1);
    });

    $('.qty-btn.minus').click(function () {
      let $input = $(this).siblings('.qty-input');
      let val = parseInt($input.val());
      if (val > parseInt($input.attr('min')) || 1) {
        $input.val(val - 1);
      }
    });



  $(".cstm-checkout-btn").click(function(){
console.log("clicked");
    // Get main product variant ID and quantity
const mainVariantId = $(".cstm_variant_all").val();
const mainQuantity = parseInt($(".qty-input").val()) || 1;

// Check if free gift checkbox is checked
// const isFreeGiftChecked = $("#free-gift-bonus-check").is(":checked");
// const freeGiftVariantId = $("#free-gift-bonus-check").val();

    var bonusValues = [];

$('.free-bonus-selection').each(function() {
  var $checkbox = $(this).find('.free-bonus-input input[type="checkbox"]');
  if ($checkbox.is(':checked')) {
    bonusValues.push(parseInt($checkbox.val()));
  }
});
    
const products = [];

// Step 1: Get current cart
fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    const cartItemIds = cart.items.map(item => item.variant_id);
console.log("in cart js");
    // Step 2: Add main product
    if (mainVariantId && mainQuantity > 0) {
      products.push({
        id: parseInt(mainVariantId),
        quantity: mainQuantity
      });
    }

    // Step 3: Check free gift logic
    bonusValues.forEach(function(bonusId) {
  const alreadyInCart = cartItemIds.includes(bonusId);

  if (!alreadyInCart) {
    products.push({
      id: bonusId,
      quantity: 1
    });
  } else {
    console.log("Bonus ID " + bonusId + " already in cart. Skipping it.");
  }
});

    console.log("Final products array:", products);
    // return false;
    // Step 4: Add to cart if there’s anything to add
    if (products.length > 0) {
      console.log("products");
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: products })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Products successfully added to cart:', data);
        // Optionally open cart drawer or show confirmation
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    } else {
      console.warn("Nothing new to add to cart.");
    }
  })
  .catch(error => {
    console.error("Failed to fetch cart:", error);
  });
  });








// MOBILE SWATCHES SCRIPT
  // color change
  $('.mobile-color').on('click', function () {
  const selectedColor = $(this).data('color');

  // Remove 'selected' class from all
  $('.mobile-color').removeClass('selected');

  // Add 'selected' class to the clicked one
  $(this).addClass('selected');

  // Find the input with the matching value
  const matchingInput = $('input[type="radio"].color-swatch').filter(function () {
    return $(this).val().trim().toLowerCase() === selectedColor.trim().toLowerCase();
  });

  if (matchingInput.length) {
    matchingInput.trigger('click');
    // console.log('Triggered click on:', matchingInput.attr('id'));
  } else {
    // console.log('No matching input found for:', selectedColor);
  }

    $(".curr_selected-color").text(selectedColor);
    checkPricesForColor(selectedColor);

  setTimeout(function() {
                    var imageIdMob = $('.cstm_variant_all option[selected]').data('image_id');
                    console.log('Selected data_image_id:', imageIdMob);
                    // The target Mead ID you want to match
                    const targetMeadId = imageIdMob; // Replace with your target ID
                    // Loop through all slides in the slick carousel
                    $('.cstm_nav_top .slick-slide').each(function(index) {
                    // Get the data-meadid from the <li> inside the current slide
                    const slideMeadId = $(this).find('li').data('meadid');

                      const indexId = $(this).data('slick-index');
                      
                    // Check if the current slide's data-meadid matches the target
                    if (slideMeadId == targetMeadId) {
                    // Use Slick's slickGoTo method to go to the matched slide's index
                    $('.cstm_nav_top').slick('slickGoTo', indexId);
                    console.log("Navigated to slide with Mead ID with INDEX:", slideMeadId, indexId);
                    return false; // Exit loop after finding the match
                    }
                    });
  
   }, 500);
    
});


  // compare price on change 
  function checkPricesForColor(color) {
  const normalizedColor = color.trim().toLowerCase();

  const matchedOptions = $('select.cstm_variant_all option').filter(function () {
    return $(this).data('color')?.trim().toLowerCase() === normalizedColor;
  });

  if (matchedOptions.length === 0) {
    // console.log(`No variants found for color: ${color}`);
    return;
  }

  matchedOptions.each(function () {
    const $option = $(this);
    const size = $option.data('size');
    const price = $option.data('prc');
    const comparePrice = $option.data('compareprc');
    const qty = $option.data('qty');  // Get the quantity

    // Debug info
    // console.log(`Size: ${size}, Price: ${price}, Compare at: ${comparePrice}, Quantity: ${qty}`);

    // Find the corresponding .mobile-size element
    const matchingSizeDiv = $(`.mobile-size`).filter(function () {
      return $(this).data('size')?.trim().toLowerCase() === size?.trim().toLowerCase();
    });

    if (matchingSizeDiv.length) {
      const pricingHeader = matchingSizeDiv.find('.pricing-header');

      pricingHeader.html(`
        <p class="promo-price">
          <span class="strikethrough-price">${comparePrice}</span>
          <span class="nonstrikethrough-price">${price}</span>
        </p>

      `);
              // <p class="in-stock">${qty} Sets Left</p>  <!-- Display the quantity in stock -->
    } else {
      // console.log(`No matching .mobile-size found for size: ${size}`);
    }
  });
}



  


  // size change mobile
  $('.mobile-size').on('click', function () {
  const selectedSize = $(this).data('size').trim();

  // Handle visual selection class
  $('.mobile-size').removeClass('selected');
  $(this).addClass('selected');

  const $select = $('#Option1-template--24129289945372__featured_product_NxfinK');
  let matchFound = false;

  $select.find('option').each(function () {
    const optionVal = $(this).val().trim();
    if (optionVal.toLowerCase() === selectedSize.toLowerCase()) {
      $(this).prop('selected', true);
      matchFound = true;
    } else {
      $(this).prop('selected', false);
    }
  });

  if (matchFound) {
    // Force value and trigger Vue-compatible native change event
    $select[0].value = selectedSize;
    const event = new Event('change', { bubbles: true });
    $select[0].dispatchEvent(event);

    // console.log('Size selected:', selectedSize);
  } else {
    console.warn('No matching size found for:', selectedSize);
  }
    $(".curr_selected-size").text(selectedSize);
});





// select qty on mobile with dropdown

  // Toggle dropdown on click
  $('.dropdown-selection-outer-box').on('click', function (e) {
    e.stopPropagation(); // Prevent event from bubbling to document
    $(this).find('.dropdown-list').toggle(); // Toggle dropdown
  });

  // Handle option click
  $('.dropdown-option').on('click', function (e) {
    e.stopPropagation(); // Prevent it from also triggering the toggle
    let selectedValue = $(this).data('value');
    let dropdownBox = $(this).closest('.dropdown-selection-outer-box');

    // Update both the text and the input field
    dropdownBox.find('#quantity-number').text(selectedValue);  // Update the text
    $(".qty-function").find('.qty-input').val(selectedValue);         // Update the input field

    // Close the dropdown
    $(this).parent().hide();
  });

  // Close dropdown when clicking outside
  $(document).on('click', function () {
    $('.dropdown-list').hide();
  });


// scrolling slider for size and color
  const scrollAmount = 200; // px to scroll on each click

// Smooth scroll on the left arrow click
$('.accordion-arrow-left').on('click', function () {
  const $scrollContainer = $(this).closest('.main-option').find('.all_option_wrap'); // Get the specific container
  $scrollContainer[0].scrollLeft -= scrollAmount;  // Scroll to the left by scrollAmount
});

// Smooth scroll on the right arrow click
$('.accordion-arrow-right').on('click', function () {
  const $scrollContainer = $(this).closest('.main-option').find('.all_option_wrap'); // Get the specific container
  $scrollContainer[0].scrollLeft += scrollAmount;  // Scroll to the right by scrollAmount
});


// Sticky button on scroll
const $checkoutBtn = $('.check-qty-wrapp .cstm-checkout-btn');
const $stickyButton = $('.sticky-buybutton');
const $window = $(window);

// Track the scroll position
$window.on('scroll', function () {
  const btnOffsetTop = $checkoutBtn.offset().top;
  const windowScrollTop = $window.scrollTop();

  // Show sticky when the button is 85px from top (or has gone above that point)
  if (btnOffsetTop < windowScrollTop + 85) {
    $stickyButton.addClass('show-sticky');
  } else {
    $stickyButton.removeClass('show-sticky');
  }
});





  // price .00 remove onload
   const $targetNode = $('[data-compare-price]');

  if ($targetNode.length) {
    const observer = new MutationObserver(function () {
      let priceText = $targetNode.text().trim();

      if (priceText.endsWith('.00')) {
        $targetNode.text(priceText.replace('.00', ''));
      }
    });

    observer.observe($targetNode[0], {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }


  // play/pause video on scroll
   function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  function checkVideos() {
    $('.custom_imageitem video').each(function () {
      const video = this;

      if (isInViewport(video)) {
        video.play();
      } else {
        video.pause();
      }
    });
  }

  // Run on scroll and initial load
  $(window).on('scroll resize', checkVideos);
  checkVideos();
  
  });



// COCH HOODIE JS

  // slider for the pair with it product section at the coch hoodie landing page
$(document).ready(function(){
   $('.pair-it-with').slick({
      // slidesToShow: 4,
      // slidesToScroll: 1,
      // arrows: true,
      // dots: false,
      // infinite: false,
      // responsive: [
      //   {
      //     breakpoint: 1024,
      //     settings: {
      //       slidesToShow: 3
      //     }
      //   },
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       slidesToShow: 2
      //     }
      //   },
      //   {
      //     breakpoint: 480,
      //     settings: {
      //       slidesToShow: 1
      //     }
      //   }
      // ]
       dots: false,
                    infinite: false,
                    speed: 300,
                    slidesToShow: 2,
                    centerMode: false,
                    initialSlide: 0,
                    responsive: [
                      {
                        breakpoint: 1200,
                        settings: {
                          slidesToShow: 2,
                        },
                      },
                      {
                        breakpoint: 768,
                        settings: {
                          slidesToShow: 2,
                        },
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: 2,
                        },
                      },
                    ],
    });

    });


    document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.pair-it-with__add').forEach(function(button) {
    button.addEventListener('click', function() {
      const variantId = this.dataset.idd;
      if (!variantId) return;

      // Disable button to prevent double-click
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Added to cart:', data);
        this.disabled = false;
        
        // Optional: update cart drawer or notify user
        // alert(`${data.title} added to cart!`);
      })
      .catch(err => {
        console.error(err);
        this.disabled = false;
        alert('Could not add to cart.');
      });
    });
  });
});
